export const Getter = {
  innerHeightRem: state => { return state.Other.innerHeightRem }, // 设置html高度
  loading: state => { return state.Other.loading }, // 设置loading
}
